import { http } from "@/configurations/axios";

export const getStatusSicredi = (contaBancariaId) =>
  http.get(`/financeiro/contas-bancarias/${contaBancariaId}/sicredi/status`);

export const testarConexaoSicredi = (contaBancariaId) =>
  http.post(
    `/financeiro/contas-bancarias/${contaBancariaId}/sicredi/testar-conexao`
  );

export const consultarBoletoSicredi = (contaBancariaId, nossoNumero) =>
  http.get(
    `/financeiro/contas-bancarias/${contaBancariaId}/sicredi/boletos/${nossoNumero}`
  );

export const gerarPdfSicredi = (contaBancariaId, nossoNumero) =>
  http.get(
    `/financeiro/contas-bancarias/${contaBancariaId}/sicredi/boletos/${nossoNumero}/pdf`
  );

export default {
  getStatusSicredi,
  testarConexaoSicredi,
  consultarBoletoSicredi,
  gerarPdfSicredi,
};
